import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const CalendarWrapperCommon = styled.div<{ $isDayGridMonth: boolean }>`
  padding-top: 52px;
  width: 100%;
  gap: 16px;
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.black9};
  & > :first-child {
    margin-bottom: 0;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    padding-top: 24px;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    padding-top: 0px;
  }
  .fc-daygrid-more-link {
    display: block;
    width: 100%;
  }
  .fc-daygrid-day-top {
    flex-direction: row;
    justify-content: center;
    & > a {
      color: ${({ theme }) => theme.colors.black9};
    }
  }
  .fc-day-today .fc-daygrid-day-top .fc-daygrid-day-number {
    display: flex;
    width: 24px;
    height: 24px;
    padding: 4px;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    background: ${({ theme }) => theme.colors.purple7};
    color: ${({ theme }) => theme.colors.white};
  }
  .fc-daygrid-day-bg {
    display: none;
  }

  .fc-daygrid-day-frame {
    &::before {
      display: none;
    }
    &::after {
      display: none;
    }
  }
  .fc-daygrid-day-frame.fc-scrollgrid-sync-inner {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .fc-daygrid-day {
    padding: ${({ $isDayGridMonth }) => (!$isDayGridMonth ? '0px' : '4px')};
  }
  .fc-daygrid-day.fc-day-today {
    background-color: ${({ theme }) => theme.colors.white};
  }
  .fc-timegrid-col.fc-day-today {
    background-color: ${({ theme }) => theme.colors.white};
  }

  .fc-theme-standard th {
    border: none;
    border-bottom: 1px solid ${({ theme }) => theme.colors.black3};
  }

  .fc-scrollgrid {
    border: none;
  }
  .fc-scrollgrid table {
    border-left-style: inherit;
  }

  .fc-more-popover {
    border: none;
    border-radius: 8px;
    width: 350px;
    background: ${({ theme }) => theme.colors.white};
    box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
      0px 9px 28px 8px rgba(0, 0, 0, 0.05);
  }
  .fc-popover-header {
    border-bottom: none;
    background: ${({ theme }) => theme.colors.white};
    display: flex;
    border-radius: 8px;
    padding: 16px 20px 8px 20px;
    justify-content: space-between;
    align-items: flex-start;
    gap: 24px;
    align-self: stretch;
  }
  .fc-popover-title {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.black9};
  }
  .fc .fc-more-popover .fc-popover-body {
    padding: 16px 20px 8px 20px;
  }
  .fc-popover-body {
    padding: 16px 20px 8px 20px;
    display: flex;
    max-height: 160px;
    overflow-y: auto;
    flex-direction: column;
    gap: 8px;
  }
  .fc-icon-x::before {
    content: '';
  }
  .fc-popover-close {
    color: ${({ theme }) => theme.colors.black6};
    width: 24px;
    height: 24px;
  }
  .fc-day-other {
    background: ${({ theme }) => theme.colors.black1};
  }
  .fc-timegrid-slot {
    height: 48px;
  }
  .fc-timegrid-col-events {
    width: 100%;
  }
  .fc-timegrid-slot-label {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    display: inline-flex;
    padding: 2px 8px;
    text-align: right;
    justify-content: flex-end;
    align-items: flex-start;
    width: 60px;
  }
  .fc-event:hover {
    background-color: inherit !important;
  }
  .fc-daygrid-more-link:hover {
    background-color: inherit !important;
  }
  .fc-list-day-text {
    color: ${({ theme }) => theme.colors.black9};
  }
  .fc-list-day-side-text {
    color: ${({ theme }) => theme.colors.black9};
  }
  .fc-timegrid-now-indicator {
    background-color: ${({ theme }) => theme.colors.purple6};
    height: 2px;
  }
`;

export const MoreEventsWrapper = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  display: flex;
  padding: 2px 8px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  color: ${({ theme }) => theme.colors.black9};
  &:hover {
    border-radius: 3px;
    background-color: ${({ theme }) => theme.colors.black2};
  }
`;
